import React from 'react';
import PropTypes from 'prop-types';
import Button from 'new-ui/Components/Button';
import { THEMES } from 'new-ui/constants';
import { PopupContent, PopupTitle } from 'new-ui/Components/Popup';
import styles from './BiomarkersNotFound.module.css';

export const BiomarkersNotFound = ({ onUploadClick, onNotNowClick }) => (
  <div>
    <PopupTitle>Please upload NGS documents</PopupTitle>
    <PopupContent>Please upload your NGS documents</PopupContent>

    <div className={styles.actions}>
      <Button
        theme={THEMES.ORANGE_FULL}
        action={onUploadClick}
        title="Upload"
      />
      <Button
        theme={THEMES.GREY}
        title="Not now"
        action={onNotNowClick}
      />
    </div>
  </div>
);

BiomarkersNotFound.propTypes = {
  onUploadClick: PropTypes.func,
  onNotNowClick: PropTypes.func,
};
